import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../api";

export default function ConversionDetail() {
  const { id } = useParams();
  const [conv, setConv] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => { api.get(`/conversions/${id}`).then((res) => setConv(res.data)).catch(() => setError("Conversion not found")); }, [id]);
  if (error) return <div className="empty" data-testid="conversion-error">{error}</div>;
  if (!conv) return <div className="loading">Loading…</div>;
  return (
    <div data-testid="conversion-detail-page">
      <header className="page-head"><div><Link to="/conversions" className="back-link">← Conversions</Link><h1>{conv.shopifyOrderName || conv.shopifyOrderId}</h1></div><span className="badge badge-gray">{conv.orderStatus}</span></header>
      <div className="detail-grid">
        <div><span className="muted">Affiliate</span><div>{conv.affiliateName || conv.affiliateCode || "—"}</div></div>
        <div><span className="muted">Currency</span><div>{conv.currency || "—"}</div></div>
        <div><span className="muted">Original Commission</span><div>{conv.originalCommissionAmount ?? "—"}</div></div>
        <div><span className="muted">Adjustments</span><div>{conv.adjustmentTotal ?? "—"}</div></div>
        <div><span className="muted">Net Commission</span><div>{conv.netCommissionAmount ?? "—"}</div></div>
        <div><span className="muted">Maturity</span><div>{conv.maturityStatus}</div></div>
        <div><span className="muted">Payment</span><div>{conv.paymentStatus}</div></div>
        <div><span className="muted">Order Date</span><div>{conv.orderCreatedAt ? new Date(conv.orderCreatedAt).toLocaleString() : "—"}</div></div>
      </div>
      <h2 className="section-title">Line Items</h2>
      {(!conv.items || conv.items.length === 0) ? <div className="empty" data-testid="items-empty">No line items recorded.</div> : (
        <div className="table-wrap"><table data-testid="items-table">
          <thead><tr><th>Title</th><th>SKU</th><th>Qty</th><th>VAT removed</th><th>Net total (excl. VAT)</th><th>Original Commission</th><th>Adjustments</th><th>Net Commission</th><th>Rate / Rule</th><th>Order / Maturity / Payment</th></tr></thead>
          <tbody>{conv.items.map((item) => (
            <tr key={item.id} data-testid={`item-row-${item.id}`}><td>{item.title}</td><td>{item.sku || "—"}</td><td>{item.quantity}</td><td>{item.taxAmount ?? "0.00"}</td><td>{item.netTotal}</td><td>{item.originalCommissionAmount ?? "—"}</td><td>{item.adjustmentTotal ?? "—"}</td><td>{item.netCommissionAmount ?? "—"}</td><td>{item.appliedRate ?? "—"} / {item.ruleType || "—"}</td><td>{item.orderStatus || "legacy_unmigrated"} / {item.maturityStatus || "—"} / {item.paymentStatus || "—"}</td></tr>
          ))}</tbody>
        </table></div>
      )}
      <h2 className="section-title">Legacy source / audit snapshot</h2>
      <div className="detail-grid" data-testid="legacy-audit">
        <div><span className="muted">Legacy status</span><div>{conv.legacyStatus}</div></div>
        <div><span className="muted">Legacy commission</span><div>{conv.legacyCommissionAmount}</div></div>
        <div><span className="muted">Legacy commissionable total</span><div>{conv.commissionableTotal}</div></div>
      </div>
    </div>
  );
}

